import React from "react";
import { Table } from "@mantine/core";
import { CustomTableProps, RowInteractions, RowStyle } from "../../types";

const CustomTable: React.FC<CustomTableProps> = ({
  headers,
  rows,
  onRowClick,
  hoverableRow = false,
  commonData = {},
}) => {
  return (
    <Table.ScrollContainer minWidth={500}>
      <Table
        withRowBorders={false}
        style={{ borderCollapse: "separate", borderSpacing: "0 10px" }}
      >
        {/* Table Headers */}
        <Table.Thead>
          <Table.Tr>
            {headers.map((header, index) => (
              <Table.Th key={index}>{header?.label}</Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>

        {/* Table Body */}
        <Table.Tbody>
          {rows.map((rowData, rowIndex) => {
            const rowStyle = rowData._rowStyle as RowStyle | undefined;
            const defaultBg = rowStyle?.backgroundColor || "white";
            const hoverBg = rowStyle?.hoverBackgroundColor || "#e6f7ff";

            return (
            <Table.Tr
              key={rowIndex}
              onClick={() => onRowClick && onRowClick(rowData)}
              style={{
                backgroundColor: defaultBg,
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor: onRowClick ? "pointer" : "default",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) =>
                hoverableRow &&
                (e.currentTarget.style.backgroundColor = hoverBg)
              }
              onMouseLeave={(e) =>
                hoverableRow &&
                (e.currentTarget.style.backgroundColor = defaultBg)
              }
            >
              {headers.map((header, cellIndex) => {
                const cellData = rowData[header.accessor];

                const cellValue =
                  cellData &&
                  (React.isValidElement(cellData) ||
                    typeof cellData === "string")
                    ? cellData
                    : cellData && typeof cellData === "object"
                    ? (
                        cellData as RowInteractions & {
                          component: React.ReactNode;
                        }
                      )?.component
                    : null;

                const { hoverableCell = false, onCellClick } = ((cellData &&
                  typeof cellData === "object" &&
                  cellData) ||
                  {}) as RowInteractions & { component: React.ReactNode };

                return (
                  <Table.Td
                    key={cellIndex}
                    onClick={(e) => {
                      if (onCellClick) {
                        e.stopPropagation(); // Prevent row click when cell is clicked
                        onCellClick(rowData);
                      }
                    }}
                    style={{
                      backgroundColor: "inherit",
                      padding: "10px",
                      borderTopLeftRadius: cellIndex === 0 ? "8px" : undefined,
                      borderBottomLeftRadius:
                        cellIndex === 0 ? "8px" : undefined,
                      borderTopRightRadius:
                        cellIndex === headers.length - 1 ? "8px" : undefined,
                      borderBottomRightRadius:
                        cellIndex === headers.length - 1 ? "8px" : undefined,
                      cursor: hoverableCell ? "pointer" : "inherit",
                      transition: "background-color 0.3s",
                      zIndex: 1
                    }}
                    onMouseEnter={(e) =>
                      hoverableCell &&
                      (e.currentTarget.style.backgroundColor = "#e6f7ff")
                    }
                    onMouseLeave={(e) =>
                      hoverableCell &&
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    {cellValue === "__commonData__"
                      ? commonData[header.accessor]?.(rowData) || null
                      : cellValue}
                  </Table.Td>
                );
              })}
            </Table.Tr>
          );
          })}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
};

export default CustomTable;
